 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0,
 		10: 0,
 		11: 0,
 		72: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0,
 		10: 0,
 		11: 0,
 		72: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~02240700","1":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","2":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","3":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-highlights~route-hom~7e900d96","4":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-part~0836b975","5":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-schedule","6":"route-account~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","12":"route-account~route-signup","17":"route-MapView","18":"route-TermsAndPrivacy","19":"route-account","20":"route-adminAdvertisements","21":"route-adminAnnouncements","22":"route-adminCameraInfo","23":"route-adminCameraSettings","24":"route-adminConfigurations","25":"route-adminHabitats","26":"route-adminOnlineUsersInfo","27":"route-adminPartners","28":"route-adminPlaylists","29":"route-adminTestNewModelsForAiKeeper","30":"route-adminUsers","31":"route-album","32":"route-emailVerify","33":"route-feed","34":"route-gift","35":"route-habitat","36":"route-habitats","37":"route-help","38":"route-highlights","39":"route-home","40":"route-importBundleUsers","41":"route-login","42":"route-myAlbum","43":"route-notFound","44":"route-notifications","45":"route-partnerDonation","46":"route-passwordReset","47":"route-profile","48":"route-redeem","49":"route-reports","50":"route-schedule","51":"route-signup","52":"route-socialLogin","53":"route-softReload","54":"route-talkSchedule","55":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"fc4f5","1":"194fe","2":"058b0","3":"4bc46","4":"cbc95","5":"ff9d9","6":"fbc0a","7":"3e845","8":"9a87c","9":"5dd1d","10":"e656e","11":"231ed","12":"ad758","13":"9f9da","17":"9b949","18":"66d7e","19":"ccfbf","20":"52b5f","21":"b8cd5","22":"93a48","23":"ae117","24":"10efe","25":"df63f","26":"5f7b5","27":"7199c","28":"19b63","29":"72148","30":"1054c","31":"2c08a","32":"d367a","33":"0006a","34":"2c072","35":"9064a","36":"c4534","37":"6c94f","38":"74d43","39":"5e618","40":"ef3d7","41":"4606b","42":"47f6a","43":"2f06d","44":"1f564","45":"2232e","46":"a7cb3","47":"0b338","48":"d4c22","49":"1a022","50":"5c97d","51":"fbe44","52":"050e8","53":"860b2","54":"4beb8","55":"15de9","56":"adbd5","57":"9a5b4","58":"7ab1a","59":"a566d","60":"3cf61","61":"38338","62":"7d838","63":"f393b","64":"be863","65":"389f6","66":"a2276","67":"ba9eb","68":"1d201","69":"992d8","70":"3a8d9","71":"2f332","73":"427c0","74":"81f5d","75":"b4483","76":"1ef97","77":"c2c3d"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"7":1,"9":1,"13":1,"17":1,"19":1,"23":1,"25":1,"27":1,"30":1,"31":1,"32":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"41":1,"42":1,"43":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"54":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"63":1,"65":1,"66":1,"67":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~02240700","1":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","2":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","3":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-highlights~route-hom~7e900d96","4":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-part~0836b975","5":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-schedule","6":"route-account~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","12":"route-account~route-signup","17":"route-MapView","18":"route-TermsAndPrivacy","19":"route-account","20":"route-adminAdvertisements","21":"route-adminAnnouncements","22":"route-adminCameraInfo","23":"route-adminCameraSettings","24":"route-adminConfigurations","25":"route-adminHabitats","26":"route-adminOnlineUsersInfo","27":"route-adminPartners","28":"route-adminPlaylists","29":"route-adminTestNewModelsForAiKeeper","30":"route-adminUsers","31":"route-album","32":"route-emailVerify","33":"route-feed","34":"route-gift","35":"route-habitat","36":"route-habitats","37":"route-help","38":"route-highlights","39":"route-home","40":"route-importBundleUsers","41":"route-login","42":"route-myAlbum","43":"route-notFound","44":"route-notifications","45":"route-partnerDonation","46":"route-passwordReset","47":"route-profile","48":"route-redeem","49":"route-reports","50":"route-schedule","51":"route-signup","52":"route-socialLogin","53":"route-softReload","54":"route-talkSchedule","55":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"ee920","3":"31d6c","4":"31d6c","5":"31d6c","6":"31d6c","7":"18e4e","8":"31d6c","9":"b7595","10":"31d6c","11":"31d6c","12":"31d6c","13":"91d99","17":"963e8","18":"31d6c","19":"94282","20":"31d6c","21":"31d6c","22":"31d6c","23":"60af3","24":"31d6c","25":"b36ec","26":"31d6c","27":"95288","28":"31d6c","29":"31d6c","30":"06749","31":"91594","32":"7990d","33":"31d6c","34":"362de","35":"dde09","36":"60ed8","37":"3a1a1","38":"08159","39":"a27c5","40":"31d6c","41":"1b2e4","42":"40d41","43":"5318a","44":"31d6c","45":"0817e","46":"5255f","47":"8c877","48":"a3247","49":"576ae","50":"e3a5f","51":"3a45d","52":"31d6c","53":"31d6c","54":"ba6f8","55":"31d6c","56":"440f4","57":"1e8d3","58":"c51fe","59":"f177c","60":"1fa4d","61":"b2ca4","62":"31d6c","63":"917a7","64":"31d6c","65":"65381","66":"91a66","67":"756f3","68":"31d6c","69":"31d6c","70":"31d6c","71":"31d6c","73":"31d6c","74":"31d6c","75":"31d6c","76":"31d6c","77":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
